// reducer.js
'use strict';
import { combineReducers } from 'redux-immutable';
import messages from './messages.js';
import me from './me.js';
import modals from './modals.js';
import networkings from './networkings.js';
import paginations from './paginations.js';
import lists from './lists.js';
import users from './users.js';
import messagePacks from './messagePacks.js';
import chatrooms from './chatrooms.js';
import gift from './gift.js';
import diamondPacks from './diamondPacks.js';
import operations from './operations.js';
import orders from './orders.js';
import routeHistory from './routeHistory.js';
import journalLogs from './journalLogs.js';
import remoteConfig from './remoteConfig.js';
import hashtags from './hashtags.js';
import categories from './categories.js';
import revenue from './revenue.js';
import liveStream from './liveStream.js';
import goals from './goals.js';
import notifications from './notifications.js';
import intercomArticles from './intercomArticles.js';
import assets from './assets.js';
import shortLink from './shortLink.js';
import backpack from './backpack.js';
import games from './games.js';
import products from './products.js';
import decryptedResources from './decryptedResources.js';
import externalData from './externalData.js';
import shopSections from './shopSections.js';
import missions from './missions.js';
// -- PLOP_PREPEND_REDUCER_IMPORT --

const reducers = {
  messages,
  me,
  modals,
  networkings,
  paginations,
  lists,
  users,
  messagePacks,
  chatrooms,
  gift,
  diamondPacks, // TODO: change to skus
  operations,
  orders,
  routeHistory,
  journalLogs,
  remoteConfig,
  hashtags,
  categories,
  revenue,
  liveStream,
  goals,
  notifications,
  intercomArticles,
  assets,
  shortLink,
  backpack,
  games,
  products,
  decryptedResources,
  externalData,
  shopSections,
  missions,
  // -- PLOP_PREPEND_REDUCER --
};

export const createRootReducer = router =>
  combineReducers({
    router,
    ...reducers,
  });

export default combineReducers(reducers);
